import { ApolloCache } from '@apollo/client';
import { getAppContext } from './app';

export enum QUERY_NAAME {
    ORGANIZATIONS = 'organizations',
    USERS = 'Users',
    PROJECTS = 'projects',
    EPICS = 'epics',
    WORKPACKAGES = 'workPackages',
    ISSUES = 'issues',
    MACHINES = 'machines',
    LOCATIONS = 'locations'
}

export const getClient = () => {
    const cntx = getAppContext();
    return cntx ? cntx.client : null;
};

export const evictQueryData = (client: any, queryName: string, args?: any) => {
    if (client && client.cache) {
        client.cache.evict({
            id: 'ROOT_QUERY',
            fieldName: queryName,
            broadcast: false,
            args: args ? args : {}
        });
    }
};

export const deleteFromCache = (client: any, queryName: string) => {
    if (client && client.cache) {
        client.cache.evict({ id: 'ROOT_QUERY', fieldName: queryName });
    }
};

export const addToCache = (cache: any, Query: any, key: string, newData: any) => {
    const data = cache.readQuery({ query: Query }) as any;

    if (!data) {
        return;
    }

    let array = Array.from(data && key in data ? data[key] : []);
    array.push(newData);

    let updatedData = { ...data };
    updatedData[key] = array;

    cache.writeQuery({ query: Query, data: updatedData });
};

export const updateCache = (
    cache: any,
    Query: any,
    key: string,
    idKey: string,
    newData: any,
    itemId: string
) => {
    const data = cache.readQuery({ query: Query }) as any;
    if (!data) {
        return;
    }

    let array = Array.from(data && key in data ? data[key] : []);

    const indx = array?.findIndex((item: any) => {
        return item && idKey in item && item[idKey] && item[idKey] == itemId;
    });

    if (indx >= 0 && indx < array?.length) {
        array[indx] = newData;
    }
    let updatedData = { ...data };

    updatedData[key] = array;

    cache.writeQuery({ query: Query, data: updatedData });
};

export const removeFromCache = (
    cache: any,
    Query: any,
    key: string,
    idKey: string,
    itemId: string
) => {
    const data = cache.readQuery({ query: Query }) as any;
    if (!data) {
        return;
    }
    let array = Array.from(data && key in data ? data[key] : []);
    const indx = array?.findIndex((item: any) => {
        return item && idKey in item && item[idKey] && item[idKey] == itemId;
    });
    if (indx >= 0 && indx < array?.length) {
        array.splice(indx, 1);
    }
    let updatedData = { ...data };
    updatedData[key] = array;
    cache.writeQuery({ query: Query, data: updatedData });
};

/**
 *
 * @param array An array of items that may contain null or undefined values
 * @returns Array of items that are not null or undefined
 */
export function nonNull<T>(array: Array<T | null | undefined> | null): Array<T> {
    if (!array) return [];
    return array.filter(Boolean) as Array<T>;
}
